

export interface IMonetaryAmount {
  by: EMonetaryAmountBy;
  value: number;
  currency: ECurrency;
}

export interface ITime {
  minutes: number;
  formatted: string;
}

export enum ECurrency {
  USD = 'USD',
  MXN = 'MXN',
}

export enum EMonetaryAmountBy {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  UNIQUE = 'unique',
  PER_ITEM = 'per_item',
  PER_SQUARE_FOOT = 'per_square_foot',
  PER_CAR_SPACE = 'per_car_space',
  PER_FLOOR = 'per_floor',
}